import { memo } from 'react';
import { useCreatePath } from 'react-admin';
import { Link } from 'react-router-dom';
import ContentCreate from '@mui/icons-material/Create';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = e => e.stopPropagation();

const EditButton = ({
  basePath = '',
  label = 'ra.action.edit',
  record = {},
  icon = <ContentCreate />,
  state = {},
  cbAddToState = null,
  customPath,
}) => {
  const createPath = useCreatePath();
  return (
    <Button
      component={Link}
      to={{
        pathname:
          customPath ||
          createPath({ resource: basePath, id: record.id, type: 'edit' }),
        state: cbAddToState ? cbAddToState(state, record) : state,
      }}
      label={label}
      onClick={stopPropagation}
    >
      {icon}
    </Button>
  );
};

EditButton.propTypes = {
  basePath: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  icon: PropTypes.element,
  state: PropTypes.object,
  cbAddToState: PropTypes.func,
  customPath: PropTypes.string,
};

export default memo(EditButton, (props, nextProps) => {
  return (
    props.translate !== nextProps.translate ||
    (props.record && nextProps.record && props.record.id !== nextProps.record.id) ||
    props.basePath !== nextProps.basePath ||
    (props.record == null && nextProps.record != null)
  );
});
